// extracted by mini-css-extract-plugin
var _1 = "CardMoveStep_dropdownMenu__Huvbe";
var _2 = "CardMoveStep_text__AwHbK";
export { _1 as "dropdownMenu", _2 as "text" }
